export default __webpack_public_path__ + "static/media/campaign-approved-img.4b637a13.png";